/* eslint-disable max-statements */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import {
	BsFillArrowLeftCircleFill,
	BsFillArrowRightCircleFill
} from 'react-icons/bs';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import validator from 'validator';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetUnsavedChangesAction } from '../../../../redux/actions/globalAction';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { DatePickerComponent } from '../../../Utils/Components/datePicker/datePicker';
import { DataNotFoundAnimation } from '../../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../../Utils/LoadingAnimations/loadingAnimation';
import { stateNotificationsEnum } from '../../../Utils/notification';
import SaveButton from '../../../Utils/saveButton';
import Quote from '../quote';
import CopyToTopicModalContent from './copyImageToTopicModal';
import 'react-image-crop/dist/ReactCrop.css';
import CropImage from './CropImage';
import { compressImage } from '../../../Utils/upload/compressFile';
import {
	setNewStandardCrop,
	setOldStandardCrop,
	setPortraitCrop,
	setStandardCrop,
	setWideCrop
} from '../../../../redux/actions/cropAction';
import axios from 'axios';
import { BackgroundImage } from '@mantine/core';
import RemoveModal from '../../../Utils/Components/removeModal';
import ParentModal from '../../../Utils/Components/parentModal';

type propsType = { isForPhone: boolean };

export enum AspectRatiosEnum {
	OLD_STANDARD = 4 / 3,
	STANDARD = 16 / 9,
	NEW_STANDARD = 16 / 10,
	WIDE = 20 / 9,
	PORTRAIT = 9 / 16,
	TALL = 9 / 20
}

export const EditImage = (props: propsType) => {
	const [isMine] = useState(true);
	const [isCollaborator, setIsCollaborator] = useState(false);
	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [title, setTitle] = useState<string>();
	const [topicName, setTopicName] = useState<string>('');
	const [description, setDescription] = useState<string>();
	const [url, setUrl] = useState<string>();
	const [photographer, setPhotographer] = useState<string>();
	const [info, setInfo] = useState<string>();
	const [source, setSource] = useState<string>();
	const [location, setLocation] = useState<string>();
	const [date, setDate] = useState<Date | null>(new Date());
	const [quotes, setQuotes] = useState<any[]>([]);

	const [nextImageId, setNextImageId] = useState<string | null>(null);
	const [prevImageId, setPrevImageId] = useState<string | null>(null);
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

	const [isCopyToTopicModalOpen, setIsCopyToTopicModalOpen] = useState(false);
	const [isCopyToTopicModalChanged, setIsCopyToTopicModalChanged] =
		useState(false);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [errorOccured, setErrorOccured] = useState(false);

	const [titleErrorMsg, setTitleErrorMsg] = useState({
		message: '',
		error: false
	});

	const [croppedFile, setCroppedFile] = useState<File>();
	const [file, setFile] = useState<File>();
	const [resizedFile, setResizedFile] = useState<File>();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const {
		standardCrop,
		newStandardCrop,
		oldStandardCrop,
		portraitCrop,
		wideCrop
	} = useTypedSelector((state) => state.crop);

	// useEffect(() => {
	// 	setIsChanged(true);
	// }, [standardCrop, newStandardCrop, oldStandardCrop, portraitCrop, wideCrop]);

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	useEffect(() => {
		if (croppedFile != null) {
			compressImage(
				croppedFile,
				() => {
					return;
				},
				setFile,
				setResizedFile
			);
		} else {
			setFile(undefined);
			setResizedFile(undefined);
		}
	}, [croppedFile]);

	const dispatch = useDispatch();

	const { topicId, imageId } = useParams();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const { user } = useTypedSelector((state) => state.auth) as any;

	async function fetchImageData() {
		let endpoint = `${globalEnv.BASE_URL}/topic/${topicId}/media/image/${imageId}/get-details`;
		if (props.isForPhone)
			endpoint = `${globalEnv.BASE_URL}/topic/${topicId}/media/phone-image/${imageId}/get-details`;
		const { data } = await axios.get(endpoint);
		return data;
	}

	const { data, isLoading, isFetching, isError } = useQuery(
		['image', topicId, imageId],
		() => fetchImageData(),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000
		}
	);

	const saveImageReq = async () => {
		interface Dto {
			[key: string]: any;
		}
		const dto: Dto = {
			title: title,
			description: description,
			info: info,
			source: source,
			photographer: photographer,
			location: location,
			date: date,
			quotes: quotes,
			isPhone: props.isForPhone,

			standardCrop: standardCrop,
			newStandardCrop: newStandardCrop,
			oldStandardCrop: oldStandardCrop,
			standardPortraitCrop: portraitCrop,
			wideCrop: wideCrop
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.put(
			`${globalEnv.BASE_URL}/admin/topic/${topicId}/media/image/${imageId}/update`,
			dto,
			config
		);
		return response;
	};

	const { mutate } = useMutation(saveImageReq, {
		onMutate: () => {
			setIsSaving(true);
		},
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated image info.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update image info."
				})
			);
			setIsSaving(false);
		}
	});

	const saveImage = async () => {
		for (let index = 0; index < quotes.length; index++) {
			const quote = quotes[index];
			if (validator.isEmpty(quote.content, { ignore_whitespace: true })) {
				dispatch(
					SetNotificationAction({
						type: stateNotificationsEnum.ERROR,
						message: 'Please fill the empty quote fields!'
					})
				);
				return;
			}
		}
		mutate();
	};

	useEffect(() => {
		try {
			if (data != null) {
				setTopicName(data.name);
				const fetchedImage = data.media[0];
				setTitle(fetchedImage.title);
				setDescription(fetchedImage.description);
				setUrl(fetchedImage.url);
				setInfo(fetchedImage.info);
				setLocation(fetchedImage.location);
				setPhotographer(fetchedImage.photographer);
				setSource(fetchedImage.source);
				const tempQuotes = fetchedImage.quotes;
				if (moment(fetchedImage.date).isValid())
					setDate(moment(fetchedImage.date).toDate());

				if (tempQuotes.length > 0) {
					tempQuotes.forEach((quote: any, index: any) => {
						tempQuotes[index] = {
							...quote,
							index: Math.floor(Math.random() * 100000)
						};
					});
					setQuotes(tempQuotes);
				}

				if (fetchedImage.standardCrop != null)
					dispatch(setStandardCrop(fetchedImage.standardCrop));

				if (fetchedImage.newStandardCrop != null)
					dispatch(setNewStandardCrop(fetchedImage.newStandardCrop));

				if (fetchedImage.wideCrop != null)
					dispatch(setWideCrop(fetchedImage.wideCrop));
				if (fetchedImage.standardPortraitCrop != null)
					dispatch(setPortraitCrop(fetchedImage.standardPortraitCrop));
				if (fetchedImage.oldStandardCrop != null)
					dispatch(setOldStandardCrop(fetchedImage.oldStandardCrop));

				const currentIdIndex = data.mediaIds.indexOf(fetchedImage._id);

				if (data.mediaIds[data.mediaIds.length - 1] != fetchedImage._id)
					setPrevImageId(data.mediaIds[currentIdIndex + 1]);

				if (data.mediaIds[0] != fetchedImage._id)
					setNextImageId(data.mediaIds[currentIdIndex - 1]);
			}
		} catch (e) {
			console.log(e);
			setErrorOccured(true);
		}
	}, [data]);

	const verifTitle = (name = '') => {
		if (validator.isEmpty(name, { ignore_whitespace: true })) {
			setTitleErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
		}
	};

	const addQuote = () => {
		setQuotes([
			...quotes,
			{
				index: Math.floor(Math.random() * 100000),
				content: '',
				metadata: ''
			}
		]);
	};

	interface IDeleteImage {
		topicId: string;
		imageId: string;
	}

	const removeImageReq = async (data: IDeleteImage) => {
		const params = new URLSearchParams();
		params.append('mediaId', data.imageId);
		params.append('topicId', data.topicId);

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axios.put(
			globalEnv.BASE_URL + '/admin/topic/delete-image',
			params,
			config
		);
		return response;
	};

	const deleteImage = useMutation(removeImageReq, {
		onSuccess: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted image from topic.'
				})
			);
			navigate('../topic/' + topicId);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete image from topic."
				})
			);
		}
	});

	const removeImage = (topicId: string, imageId: string) => {
		deleteImage.mutate({ topicId, imageId });
	};

	const navigate = useNavigate();

	return (
		<div className="h-screen pt-16">
			<Scrollbars autoHide>
				{isLoading || isFetching ? (
					<LoadingAnimComponent />
				) : isError || errorOccured ? (
					<div className="h-full ">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<div className="w-full rounded-md mx-auto">
						<div
							className="h-16 fixed z-10 w-full md:w-[95%] dark:bg-gray-800 bg-white
						transition-all duration-500"
						>
							<div className="flex flex-row w-full ml-16  md:ml-32 mt-4">
								<div className="justify-start flex-1">
									{isMine ? (
										<>
											<button
												className="btn btn-outline btn-sm mr-5 "
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => navigate('../topic/' + topicId)}
											>
												Cancel
											</button>

											<button
												className={`btn btn-outline btn-sm mr-1 btn-primary`}
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => {
													console.log('user', user._id);
													setIsCopyToTopicModalOpen(true);
												}}
											>
												Copy image to another topic
											</button>
										</>
									) : (
										<button
											className="btn btn-outline btn-sm mr-5 "
											type="button"
											style={{ transition: 'all .15s ease' }}
											onClick={() => navigate('../topic/' + topicId)}
										>
											Go back
										</button>
									)}
									<ParentModal
										visible={isCopyToTopicModalOpen}
										setModalOpen={setIsCopyToTopicModalOpen}
										isChanged={isCopyToTopicModalChanged}
										setIsChanged={setIsCopyToTopicModalChanged}
										isWarnModalOpen={isWarnModalOpen}
										setIsWarnModalOpen={setIsWarnModalOpen}
									>
										<CopyToTopicModalContent
											editorId={user._id}
											imageId={imageId}
											topicId={topicId}
											setOpen={setIsCopyToTopicModalOpen}
										/>
									</ParentModal>
								</div>
								<div className="justify-end">
									<div>
										<RemoveModal
											title={'Remove Image'}
											text={'Are you sure you want to remove this image?'}
											setModalOpen={setIsRemoveModalOpen}
											setAction={() => {
												if (topicId != null)
													if (imageId != null) removeImage(topicId, imageId);
											}}
											visible={isRemoveModalOpen}
										/>
									</div>

									<div className=" mr-16  md:mr-32">
										{isMine && !isCollaborator && (
											<button
												className="btn btn-outline btn-sm btn-error mr-1"
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => setIsRemoveModalOpen(true)}
											>
												Delete
											</button>
										)}
										{isChanged && isMine && (
											<SaveButton
												isSaving={isSaving}
												saveFunc={() => saveImage()}
											/>
										)}
									</div>
								</div>
							</div>
						</div>

						{nextImageId != null && (
							<div
								className="fixed h-[80%] w-24 md:w-32 lg:w-40 mt-14 top-[50%] translate-y-[-50%] right-0 z-10 group overflow-hidden"
								style={{
									borderRadius: '250px 0 0 250px'
								}}
							>
								<div
									className="w-full h-full group-hover:bg-gray-900 transition-all duration-300 opacity-0 group-hover:opacity-60"
									style={{
										borderRadius: '250px 0 0 250px'
									}}
								/>

								<div className="group-1 w-fit h-fit">
									<BsFillArrowRightCircleFill
										size="80"
										className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]
							text-gray-100 dark:text-primary text-center cursor-pointer
							transition-all duration-300 opacity-0 group-hover:opacity-100"
										onClick={() => {
											// This ensures Quotes state is reset so the current image's quotes don't show on the next
											setQuotes([]);
											setUrl('');
											setTitle('');
											setInfo('');
											setLocation('');
											setPhotographer('');
											setSource('');
											setPrevImageId(null);
											setNextImageId(null);
											navigate(`./../${nextImageId}`);
										}}
									/>

									<span
										className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										scale-0 origin-top group-1-hover:scale-100 z-30
										font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100
										top-[61%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
									>
										{'Next image'}
									</span>
								</div>
							</div>
						)}

						{prevImageId != null && (
							<div
								className="fixed h-[80%] w-24 md:w-32 lg:w-40 mt-14 top-[50%] translate-y-[-50%] left-0 ml-16 z-10 group overflow-hidden"
								style={{
									borderRadius: '0 250px 250px 0'
								}}
							>
								<div
									className="w-full h-full  group-hover:bg-gray-900 transition-all duration-300 opacity-0 group-hover:opacity-60"
									style={{
										borderRadius: '0 250px 250px 0'
									}}
								/>

								<div className="group-1 w-fit h-fit">
									<BsFillArrowLeftCircleFill
										size="80"
										className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]
							text-gray-100 dark:text-primary text-center cursor-pointer
							transition-all duration-300 opacity-0 group-hover:opacity-100"
										onClick={() => {
											setQuotes([]);
											setUrl('');
											setTitle('');
											setInfo('');
											setLocation('');
											setPhotographer('');
											setSource('');
											setPrevImageId(null);
											setNextImageId(null);
											navigate(`./../${prevImageId}`);
										}}
									/>

									<span
										className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										scale-0 origin-top group-1-hover:scale-100 z-30
										font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100
										top-[61%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
									>
										{'Previous image'}
									</span>
								</div>
							</div>
						)}

						<form className="mx-auto w-full max-w-3xl pt-16">
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label
										className="block uppercase tracking-wide text-gray-700
											dark:text-gray-300 text-xs font-bold mb-2"
									>
										Title
									</label>
									<input
										disabled={!isMine}
										className={`appearance-none block w-full py-3 px-4 rounded font-semibold
											text-gray-700 dark:text-white placeholder-gray-600 dark:placeholder-gray-500
											bg-stone-200 dark:bg-gray-700 border focus:outline-none transition-all duration-500
												border-stone-200 focus:border-gray-400 dark:focus:border-gray-600  ${
													titleErrorMsg.error
														? 'border-red-500'
														: 'border-gray-200 dark:border-gray-700'
												}`}
										id="grid-title"
										placeholder="Image title"
										onBlur={() => {
											verifTitle(title);
										}}
										onFocus={() => {
											setTitleErrorMsg({
												error: false,
												message: ''
											});
										}}
										onChange={(e) => {
											setTitle(e.target.value);
											setIsChanged(true);
										}}
										value={title}
									/>
									{titleErrorMsg.error ? (
										<p className="text-red-500 text-xs italic">
											Please fill out this field.
										</p>
									) : (
										<p className="text-gray-600 dark:text-gray-500 text-xs italic">
											Required
										</p>
									)}
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Info
									</label>
									<textarea
										className="inputStyle"
										id="grid-photographer"
										disabled={!isMine}
										placeholder="Specify some details about the image"
										onChange={(e) => {
											setInfo(e.target.value);
											setIsChanged(true);
										}}
										value={info}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Location
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										disabled={!isMine}
										placeholder="Paris, France"
										onChange={(e) => {
											setLocation(e.target.value);
											setIsChanged(true);
										}}
										value={location}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Photographer
									</label>
									<input
										className="inputStyle"
										id="grid-last-name"
										type="text"
										placeholder="John Doe"
										disabled={!isMine}
										onChange={(e) => {
											setPhotographer(e.target.value);
											setIsChanged(true);
										}}
										value={photographer}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Source
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										placeholder="www.example.com"
										disabled={!isMine}
										onChange={(e) => {
											setSource(e.target.value);
											setIsChanged(true);
										}}
										value={source}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Date
									</label>

									{isMine ? (
										<DatePickerComponent
											date={date}
											setDate={setDate}
											setIsChanged={setIsChanged}
										/>
									) : (
										<input
											className="inputStyle"
											id="grid-date"
											type="text"
											placeholder="July 11, 2018"
											disabled={!isMine}
											value={moment(date).format('MMMM d, yyyy')}
										/>
									)}

									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
						</form>

						{quotes.length > 0 ? (
							<div className="text-center mt-5">
								<div className="flex flex-row">
									<div className="flex-1"></div>
									<h3 className="flex-1 text-4xl font-semibold text-gray-600 dark:text-gray-500">
										QUOTES
									</h3>
									<div className="flex flex-1 justify-end">
										{isMine && (
											<button
												className="btn btn-outline btn-sm btn-primary ml-auto mt-1 mr-3 lg:mr-20"
												onClick={() => {
													addQuote();
												}}
											>
												Add Quote ➕
											</button>
										)}
									</div>
								</div>
								{quotes.map((quote, index) => (
									<Quote
										key={quote.index}
										index={index}
										id={quote._id}
										quote={quote.content}
										metadata={quote.metadata}
										isMine={isMine}
										quotes={quotes}
										setQuotes={setQuotes}
										setIsChanged={setIsChanged}
									/>
								))}
							</div>
						) : (
							isMine && (
								<div className="flex flex-1 my-5">
									<button
										className="btn btn-outline btn-sm btn-primary mx-auto"
										onClick={() => {
											addQuote();
										}}
									>
										Add Quote ➕
									</button>
								</div>
							)
						)}

						{isMine && url != null ? (
							<CropImage
								src={url}
								setUrl={setUrl}
								setIsChanged={setIsChanged}
								setCroppedFile={setCroppedFile}
								name={title != null ? title : 'preview'}
								topicId={topicId}
								imageId={imageId}
							/>
						) : (
							<BackgroundImage
								className="rounded-lg block object-cover
								object-center aspect-[16/9] mx-auto w-8/12 mb-10"
								src={url as string}
							/>
						)}
					</div>
				)}
			</Scrollbars>
		</div>
	);
};
